// Curated list of coordinate reference systems commonly used for point-cloud /
// survey data. This is intentionally NOT the full EPSG registry (6000+ entries)
// — just the systems likely to appear, so the project dropdown stays usable.
// Stored as informational metadata on the project (see the EPSG field in
// project create/edit).

export interface EpsgOption {
  code: number;
  label: string;
}

const NAMED: EpsgOption[] = [
  { code: 27700, label: 'British National Grid (OSGB36) — EPSG:27700' },
  { code: 2157,  label: 'Ireland — Irish Transverse Mercator (ITM) — EPSG:2157' },
  { code: 29903, label: 'Ireland — Irish Grid (TM75) — EPSG:29903' },
  { code: 2154,  label: 'France — RGF93 / Lambert-93 — EPSG:2154' },
  { code: 25830, label: 'Spain — ETRS89 / UTM 30N — EPSG:25830' },
  { code: 25831, label: 'Spain / Andorra — ETRS89 / UTM 31N — EPSG:25831' },
  { code: 25832, label: 'Central Europe — ETRS89 / UTM 32N — EPSG:25832' },
  { code: 25833, label: 'Central Europe — ETRS89 / UTM 33N — EPSG:25833' },
  { code: 28992, label: 'Netherlands — Amersfoort / RD New — EPSG:28992' },
  { code: 31370, label: 'Belgium — Lambert 72 — EPSG:31370' },
  { code: 3812,  label: 'Belgium — Lambert 2008 — EPSG:3812' },
  { code: 2056,  label: 'Switzerland — CH1903+ / LV95 — EPSG:2056' },
  { code: 3006,  label: 'Sweden — SWEREF99 TM — EPSG:3006' },
  { code: 2193,  label: 'New Zealand — NZGD2000 / NZTM — EPSG:2193' },
];

function utmOptions(): EpsgOption[] {
  const out: EpsgOption[] = [];
  for (let z = 1; z <= 60; z++) {
    out.push({ code: 32600 + z, label: `WGS84 / UTM zone ${z}N — EPSG:${32600 + z}` });
  }
  for (let z = 1; z <= 60; z++) {
    out.push({ code: 32700 + z, label: `WGS84 / UTM zone ${z}S — EPSG:${32700 + z}` });
  }
  for (let z = 28; z <= 38; z++) {
    if (!NAMED.some((o) => o.code === 25800 + z)) {
      out.push({ code: 25800 + z, label: `ETRS89 / UTM zone ${z}N — EPSG:${25800 + z}` });
    }
  }
  for (let z = 1; z <= 23; z++) {
    out.push({ code: 26900 + z, label: `NAD83 / UTM zone ${z}N — EPSG:${26900 + z}` });
  }
  return out;
}

export const EPSG_OPTIONS: EpsgOption[] = [...NAMED, ...utmOptions()];

export function epsgLabel(code?: number | null): string {
  if (!code) return '';
  const found = EPSG_OPTIONS.find((o) => o.code === code);
  return found ? found.label : `EPSG:${code}`;
}
